/**
 * Which monitoring locations accrue concrete maturity.
 *
 * Mirrors the maturity engine (backend services/maturity_engine.py
 * is_maturity_location) and the dashboard's has_strength rule: humidity
 * channels, site-conditions hardware (weather stations, ambient Temp &
 * Humidity) and Temperature Only locations (MonitorType '2', even on a
 * maturity pour) never accrue maturity, so their maturity, strength,
 * progress and targets mean nothing and are not shown.
 */
import type { LocationStatus } from '../services/pours';
import { isSiteConditionsChannel } from './locationChannels';

/** PourLocation.MonitorType of a Temperature Only location. */
export const TEMPERATURE_ONLY_MONITOR_TYPE = '2';

/** A Temperature Only location (MonitorType '2'). */
export const isTemperatureOnlyLocation = (l: LocationStatus): boolean =>
  (l.monitor_type ?? '').trim() === TEMPERATURE_ONLY_MONITOR_TYPE;

/** Whether a location accrues concrete maturity. Shared by the dashboard
 *  list, Location Details, the overlay charts and the control panel. */
export const locationHasMaturity = (l: LocationStatus): boolean =>
  !isSiteConditionsChannel(l) && !isTemperatureOnlyLocation(l);
